import { createGlobalCityRequest } from "../../data/globalCityApi";
import { validateGlobalCityPayload } from "../validator/validateGlobalCityPayload";

export async function createGlobalCityUseCase(payload) {
  const error = validateGlobalCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createGlobalCityRequest(payload);
}
